import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import Resize from 'vuetify/lib/directives/resize';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{directives:[{def: Resize,name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c(VCol,{attrs:{"sm":"12"}},[_c('div',{staticClass:"console",attrs:{"id":"terminal"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }